// Module
var code = "<h2>This type of asset not supporte</h2>";
// Exports
var _module_exports =code;;
var path = '/viraweb123/vw-dashboard/src/modules/sdp/wizards/new-asset/notsupportPage.html';
window.angular.module('mblowfishApp').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
export default path;